/**
 * Application configuration
 * These values should be set via environment variables in production
 */

export const config = {
  // Azure AD configuration
  azureAd: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    // Use v2.0 endpoint to get v2 tokens
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}/v2.0`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
  },

  // API configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  },

  github: {
    appClientId: import.meta.env.VITE_GITHUB_APP_CLIENT_ID,
  },
} as const;
